import FormSubmitProps from "../../../types/FormSubmitProps";
import { Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import wizardStyle from "../wizardStyle";
import FormFader from "../Common/Fader/FormFader";
import Typography from "@mui/material/Typography";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import OpposingPartyData from "../AbstractLitigationCase/OpposingPartyData";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import Group from "../../Wizard/Group";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { emailDefault, isPhoneNumberDefault, requiredValidator } from "../../../services/validationRules";
import Person from "../Common/Person/Person";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import Address from "../Common/Address/Address";
import { translate } from "../../../services/translations/translations";

type EmploymentContractOpposingPartyProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function EmploymentContractOpposingParty({ product, submitProps }: EmploymentContractOpposingPartyProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Details zu Ihrem Anliegen
          </Typography>

          <OpposingPartyData product={product} />

          <Grid size={12}>
            <Group
              type={"radio"}
              name={"contractualPartnerHasLawyer"}
              question={translate("employmentContract.contractualPartnerHasLawyer.question", values)}
              options={[
                {
                  labelText: translate("employmentContract.contractualPartnerHasLawyer.options.yes.label", values),
                  labelIcon: <CheckIcon />,
                  labelIconActive: <CheckIcon active />,
                  value: "yes",
                },
                {
                  labelText: translate("employmentContract.contractualPartnerHasLawyer.options.no.label", values),
                  labelIcon: <CrossIcon />,
                  labelIconActive: <CrossIcon active />,
                  value: "no",
                },
              ]}
              validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
            />
          </Grid>
          {values.contractualPartnerHasLawyer === "yes" && (
            <>
              <Grid
                container
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "baseline",
                }}
              >
                <Person fieldsAreRequired={false} path="opponentLawyer" headline={translate("employmentContract.opponentLawyer.headline", values)} />
                <Grid size={12}>
                  <ValidatorTextField
                    name="opponentLawFirm.organization.name"
                    label={translate("employmentContract.opponentLawFirm.organization.name.label", values)}
                  />
                </Grid>
                <Address
                  fieldsAreRequired={false}
                  path={"opponentLawFirm.organization.address"}
                  headline={translate("employmentContract.opponentLawFirm.organization.address.headline", values)}
                />
                <Grid size={12}>
                  <ValidatorTextField
                    name="opponentLawFirm.organization.mainEmail.email"
                    label={translate("employmentContract.opponentLawFirm.organization.mainEmail.label", values)}
                    validators={[emailDefault]}
                  />
                </Grid>
                <Grid size={12}>
                  <ValidatorTextField
                    name="opponentLawFirm.organization.telephone"
                    label={translate("employmentContract.opponentLawFirm.organization.telephone.label", values)}
                    validators={isPhoneNumberDefault}
                  />
                </Grid>
              </Grid>
            </>
          )}

          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
